<template>
  <el-tabs
      v-model="activeTabMap"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adCampaign" lazy>
      <div></div>
      <template #label>广告活动 <gj-badge class="ad-badge" type="num" :value="cornerMarker.countCampaign || 0"></gj-badge></template>
      <app-sb-ad-campaign
          v-if="activeTabMap == 'adCampaign'"
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="sbAdCampaign"
      ></app-sb-ad-campaign>
    </el-tab-pane>
    <el-tab-pane name="adKeyword" lazy>
      <div></div>
      <template #label>关键词 <gj-badge class="ad-badge" type="num" :value="cornerMarker.countKeywords || 0"></gj-badge></template>
      <app-sb-ad-keyword
          v-if="activeTabMap == 'adKeyword'"
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="sbAdKeyword"
      ></app-sb-ad-keyword>
    </el-tab-pane>
    <el-tab-pane name="adNegKeyword" lazy>
      <div></div>
      <template #label>否定关键词 <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeKeywords || 0"></gj-badge></template>
      <app-sb-ad-neg-keyword
          v-if="activeTabMap == 'adNegKeyword'"
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="sbAdNegKeyword"
      ></app-sb-ad-neg-keyword>
    </el-tab-pane>
    <el-tab-pane name="adProductTarget" lazy>
      <div></div>
      <template #label>商品投放 <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargeting || 0"></gj-badge></template>
      <app-sb-ad-product-target
          v-if="activeTabMap == 'adProductTarget'"
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="sbAdProductTarget"
      ></app-sb-ad-product-target>
    </el-tab-pane>
    <el-tab-pane name="adNegTarget" lazy>
      <div></div>
      <template #label>否定商品投放 <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeTargeting || 0"></gj-badge></template>
      <app-sb-ad-neg-target
          v-if="activeTabMap == 'adNegTarget'"
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="sbAdNegTarget"
      ></app-sb-ad-neg-target>
    </el-tab-pane>
    <el-tab-pane name="adSearchWord" lazy>
      <template #label>用户搜索词</template>
      <div></div>
      <app-sb-ad-search-keyword
          v-if="activeTabMap == 'adSearchWord'"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          table-name="sbAdSearchWord"
      ></app-sb-ad-search-keyword>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSbAdCampaign from "../components/ad-campaign/ad-campaign";
  import AppSbAdKeyword from "../components/ad-keyword/ad-keyword";
  import AppSbAdNegKeyword from "../components/ad-neg-keyword/ad-neg-keyword";
  import AppSbAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSbAdProductTarget from "../components/ad-product-target/ad-product-target";
  import AppSbAdSearchKeyword from "../components/ad-search-word/ad-search-word";
  import {initDateMixin, inMarketMixin, inPortfolioMixin, tabResizeMixin} from "../../common/mixin";
  
  export default {
    name: "app-sb-ad-manager",
    components: {AppSbAdNegKeyword, AppSbAdKeyword, AppSbAdCampaign, AppSbAdNegTarget, AppSbAdProductTarget, AppSbAdSearchKeyword},
    mixins: [inMarketMixin, inPortfolioMixin, tabResizeMixin, initDateMixin],
    inject: [ 'cornerMarkerMap' ],
    props: {
      activeTab: {
        default: 'adCampaign',
      }
    },
    data() {
      return {
        activeTabMap: "adCampaign",
        timeStamp:null
      }
    },
    computed: {
      cornerMarker() {
        return this.cornerMarkerMap()
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.timeStamp){
            this.activeTabMap = this.$route.query.activeTabMap;
            this.timeStamp = this.$route.query.timeStamp;
          }
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  .vxe-table--render-default:not(.is--empty).is--footer.is--scroll-x .vxe-table--body-wrapper{
    overflow-x: hidden;
  }
  // /deep/.fixed-left--wrapper.vxe-table--body-wrapper  {
  //   overflow-x: hidden !important;
  // }
  // /deep/.el-tabs__item {
  //   font-size: 12px;
  //   height: 36px;
  //   line-height: 36px;
  // }
  .ad-badge{
    /deep/ .el-badge__content{
      font-weight: 600;
      font-family: PingFangSC-Semibold;
    }
  }
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
